/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingMessage } from '../shared/LoadingMessage';
import { getHostName, localizeUser, publishNewRelicCustomAttribute } from '../../util/utils';
import { REDIRECT_URL_AAFES } from '../../util/URL';

export const AAFESAuth = ({ requestBody }) => {

  const exchangeToken = requestBody.aafes_auth;
  const redirectURL = requestBody.b2bPostURL;
  const exchangeOrigin = requestBody.user_id;
  const exchangeCartId = requestBody.order_id;

  const d = '.' + window.location.hostname; // added to dynamically get the domain

  const validateToken = async (headers, body) => {
    return await fetch(getHostName() + '/storefront/auth/validate/aafes', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    });
  };

  const handleResponse = (r) => {
    // handle the response here
    if (r.success) {
      localizeUser();
      publishNewRelicCustomAttribute({ tagName: 'storefrontUserType', tagValue: 'AAFES' });
      localStorage.removeItem('thd-membershipInformation');
      location.href = '/';
    } else {
      // if not successful, redirect back to exchange
      location.href = REDIRECT_URL_AAFES;
    }
  };

  const saveDataToStorage = (r) => {
    // Save b2b PostURL in localStorage
    localStorage.setItem('exchangeRedirectUrl', redirectURL);
    // Save cart ID in localStorage
    if (r?.properties?.cartId) {
      localStorage.setItem('exchangeCartId', r.properties.cartId);
    } else {
      localStorage.removeItem('exchangeCartId');
    }
    document.cookie = `cart_activity_exchange=${r.properties.customerId}; path=/; Secure; max-age=86400`;
    // Save allowed domains in cookies
    document.cookie = `allowed_domains=${exchangeOrigin}; path=/; Secure; max-age=86400`;
  };

  useEffect(() => {
    //check if exchangeToken, redirectURL and exchangeOrigin are present
    if (exchangeToken && redirectURL && exchangeOrigin) {
      //check if domain is storefront
      if (d.includes('storefront')) {
        //if domain is storefront, add header storefront: true and add redirectURL to the request at the same level as token and cartId
        validateToken({ 'Content-Type': 'application/json', 'storefront': true },{ token: exchangeToken, cartId: exchangeCartId, properties: { returnURL: redirectURL } })
          .then(r => r.json())
          .then((r) => {
            if (!exchangeCartId) {
              document.cookie = 'THD_PERSIST_STOREFRONT=;domain=' + d + ';path=/';
            }
            handleResponse(r);
          })
          .catch((e) => {
            console.log('error: ', e);
            location.href = REDIRECT_URL_AAFES;
          });
      } else {
        //if domain is not storefront, keep header Content-Type: application/json and add cartId to the request at the same level as token
        validateToken({'Content-Type': 'application/json'}, {
          token: exchangeToken,
          cartId: exchangeCartId
        })
          .then(r => r.json())
          .then((r) => {
            //if domain is not storefront, save data to local storage
            saveDataToStorage(r);
            if (!exchangeCartId) {
              document.cookie = 'THD_PERSIST_EXCHANGE=;domain=' + d + ';path=/';
            }
            handleResponse(r);
          })
          .catch((e) => {
            console.log('error: ', e);
            location.href = REDIRECT_URL_AAFES;
          });
      }
    } else {
      // if values are missing or invalid, redirect back to exchange
      location.href = REDIRECT_URL_AAFES;
    }
  }, []);

  return (
    <LoadingMessage loadingText="Welcome Exchange Customer! Authentication is in progress..." />
  );
};

AAFESAuth.propTypes = {
  requestBody: PropTypes.object,
};

AAFESAuth.defaultProps = {
  requestBody: {},
};
